<section id="rcs">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Risk Capacity Survey: Your Profile</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">

        <p>Your Risk Capacity Survey results are almost ready. Your results are instant and will be available immediately after submitting your information.</p>

        <p>To ensure that your report is accurate we may have an IFC Investment Advisor Representative check your answers. Investing for Catholics provides faith consistent investment advice to individuals and Catholic institutions nationally. IFC welcomes the opportunity to assist you with your investing needs, please fill out the following information.</p>

        <form id="profile" method="GET" action="Profile" (ngSubmit)="profileFormSubmit()">

          <div class="inputs">

            <input [(ngModel)]="firstName" (blur)="validateFirstName()" type="text" id="profileFirstName" name="profileFirstName" placeholder="First Name" data-error="Please enter your name" value={{firstName}} />
            <div class="error profileFirstName">{{firstNameValidationText}}</div>

            <input [(ngModel)]="lastName" (blur)="validateLastName()" type="text" id="profileLastName" name="profileLastName" placeholder="Last Name" data-error="Please enter your last name" value={{lastName}} />
            <div class="error name">{{lastNameValidationText}}</div>

            <input [(ngModel)]="email" (blur)="validateEmail()" type="email" id="profileEmail" name="profileEmail" placeholder="E-mail" data-error="Please enter a valid email" value={{email}} />
            <div class="error name">{{emailValidationText}}</div>

            <input [(ngModel)]="phone" (blur)="validatePhone()" type="tel" id="profilePhoneNumber" name="profilePhoneNumber" placeholder="Phone Number: Ex: 13235551234, 1-323-555-1234, +86 323 555 1234 " data-error="Please enter your phone number" value={{phone}} />
            <div class="error phone">{{phoneValidationText}}</div>

            <select [(ngModel)]="state" type="text" id="profileState" name="profileState" placeholder="Select State" value={{state}}>
              <option [value]="" selected>Select A State:</option>
              <option value="AK">Alaska </option>
              <option value="AL">Alabama</option>
              <option value="AR">Arkansas</option>
              <option value="AZ">Arizona</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut </option>
              <option value="DC">Washington DC</option>
              <option value="DE">Delaware</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii </option>
              <option value="IA">Iowa</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="KS">Kansas </option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana </option>
              <option value="MA">Massachusetts</option>
              <option value="MD">Maryland</option>
              <option value="ME">Maine</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota </option>
              <option value="MO">Missouri</option>
              <option value="MS">Mississippi </option>
              <option value="MT">Montana</option>
              <option value="NC">North Carolina </option>
              <option value="ND">North Dakota</option>
              <option value="NE">Nebraska</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NV">Nevada </option>
              <option value="NY">New York</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon </option>
              <option value="PA">Pennsylvania</option>
              <option value="PR">Puerto Rico </option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina </option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee </option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VA">Virginia</option>
              <option value="VT">Vermont</option>
              <option value="WA">Washington</option>
              <option value="WI">Wisconsin </option>
              <option value="WV">West Virginia</option>
              <option value="WY">Wyoming </option>
              <option value="NA">Outside The United States</option>
            </select>

            @if (state=='NA') {
              <select [(ngModel)]="country" type="text" id="profileCountry" name="profileCountry" placeholder="Select Country" value={{country}}>
                <option [value]="" selected>Select Country:</option>
                <option value="Australia">Australia</option>
                <option value="Austria">Austria</option>
                <option value="Belgium">Belgium</option>
                <option value="Brazil">Brazil</option>
                <option value="Canada">Canada</option>
                <option value="China">China</option>
                <option value="Denmark">Denmark</option>
                <option value="Finland">Finland</option>
                <option value="France">France</option>
                <option value="Germany">Germany</option>
                <option value="Greece">Greece</option>
                <option value="Holland">Holland</option>
                <option value="Hong Kong">Hong Kong</option>
                <option value="India">India</option>
                <option value="Indonesia">Indonesia</option>
                <option value="Ireland">Ireland</option>
                <option value="Israel">Israel</option>
                <option value="Italy">Italy</option>
                <option value="Japan">Japan</option>
                <option value="Kuwait">Kuwait</option>
                <option value="Mexico">Mexico</option>
                <option value="Netherlands">Netherlands</option>
                <option value="New Zealand">New Zealand</option>
                <option value="Portugal">Portugal</option>
                <option value="Puerto Rico">Puerto Rico</option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="South Africa">South Africa</option>
                <option value="South Korea">South Korea</option>
                <option value="Spain">Spain</option>
                <option value="Sweden">Sweden</option>
                <option value="Switzerland">Switzerland</option>
                <option value="Taiwan">Taiwan</option>
                <option value="United Arab Emirat">United Arab Emirat</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="United States">United States</option>
                <option value="Other">Other</option>
              </select>
            }

            <h3>Your advisor will be Mary Brunson.</h3>

            <!-- <p>Select an Advisor:</p> -->

            <!-- <select [(ngModel)]="advisor" (blur)="validateAdvisor()" type="text" id="profileAdvisor" name="profileAdvisor" placeholder="Mary Brunson" value={{111}} data-error="Please select an advisor">
            <option [value]="111" selected>Mary Brunson</option>
          </select>
          <div class="error profileAdvisor">{{advisorValidationText}}</div> -->

          <!--<textarea rows="3" id="proposalMessage" placeholder="Your Message"></textarea>-->

          <!--<div class="checkbox">
          <input name="check" id="check" value="1" type="checkbox" checked="true"/><label class="terms">I accept the <a href="#terms" data-toggle="modal">terms of use</a>.</label>
        </div>-->

        <input type="submit" id="continueProfile" value="VIEW RESULTS" />
        <div id="result" class="text-center text-danger mt-3">Submitted</div>

        <div class="error">{{profileMessage}}</div>

      </div>

    </form>
  </div>
</div>
</div>
</section>